import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
import { I18nProvider } from './utils/i18n';
render(<I18nProvider data-id="element-1271">
    <App data-id="element-1272" />
  </I18nProvider>, document.getElementById('root'));